import { Openapi } from './openapi';
import { SearchRequestParams, SearchDataSource } from '../search';

export function createSearchDataSource<T>(
  api: Openapi,
  operation: string,
  parameters?: Dictionary<any>,
): SearchDataSource<T> {
  const top = 10;

  const p = parameters || {};

  return function load(q: string): Promise<T[]> {
    if (!q) {
      return Promise.resolve([]);
    }
    return api
      .request(operation, { parameters: { q, query: q, top: top, ...p } })
      .then((resp) => resp.data);
  };
}
